import { useState } from 'react'
import { flushSync } from 'react-dom'

import {
  PDF_VIEWER_ALL_TOOLS,
  PDF_VIEWER_DEFAULT_OPEN_PANELS,
  PdfViewerTool,
} from '../../PdfViewer.constants'

import {
  checkIsNarrowScreen,
  checkIsPdfViewerPanelOpenByDefault,
} from './usePdfViewerPanels.utils'

export function usePdfViewerPanels({
  defaultOpenPanels = PDF_VIEWER_DEFAULT_OPEN_PANELS,
  tools = PDF_VIEWER_ALL_TOOLS,
}) {
  const [isThumbnailsOpen, setThumbnailsOpen] = useState(
    checkIsPdfViewerPanelOpenByDefault({
      defaultOpenPanels,
      tool: PdfViewerTool.Thumbnails,
      tools,
    })
  )
  const [isSearchOpen, setSearchOpen] = useState(
    checkIsPdfViewerPanelOpenByDefault({
      defaultOpenPanels,
      tool: PdfViewerTool.Search,
      tools,
    })
  )

  // the narrow layout has room for one panel, so opening one closes the other
  function handleToggleThumbnails() {
    const nextValue = !isThumbnailsOpen

    setThumbnailsOpen(nextValue)

    if (nextValue && checkIsNarrowScreen()) {
      setSearchOpen(false)
    }
  }

  function handleToggleSearch() {
    const nextValue = !isSearchOpen

    setSearchOpen(nextValue)

    if (nextValue && checkIsNarrowScreen()) {
      setThumbnailsOpen(false)
    }
  }

  // the narrow layout hides the document under the panel, and pdf.js cannot
  // scroll a hidden container — the panel has to be gone before the page is set
  function closeThumbnailsOnNarrowScreen() {
    if (checkIsNarrowScreen()) {
      flushSync(() => {
        setThumbnailsOpen(false)
      })
    }
  }

  return {
    closeThumbnailsOnNarrowScreen,
    isSearchOpen,
    isThumbnailsOpen,
    panelProps: {
      onToggleSearch: handleToggleSearch,
      onToggleThumbnails: handleToggleThumbnails,
    },
  }
}
